import React, { useState } from 'react'
import { Button, Icon } from 'antd'

import {
  getEntityApiId,
  getEntityDescription,
  getEntityKey,
  isEntityVerified
} from '../../utils'
import './EntityListPreview.scss'

const EntityListPreview = ({
  entities,
  phase,
  isActivePhase,
  phaseBusyAction,
  onVerifyEntity,
  showFullDescriptions = false
}) => {
  const [expandedEntityKeys, setExpandedEntityKeys] = useState({})

  if (!entities.length) return null

  const toggleDescription = entityKey => {
    setExpandedEntityKeys(prev => ({
      ...prev,
      [entityKey]: !prev[entityKey]
    }))
  }

  return (
    <div
      className={`creative-direction-chat__entity-list${
        showFullDescriptions
          ? ' creative-direction-chat__entity-list--drawer'
          : ''
      }`}
    >
      {entities.map((entity, index) => {
        const entityKey = getEntityKey(entity, index)
        const description = getEntityDescription(entity)
        const isExpanded =
          showFullDescriptions || Boolean(expandedEntityKeys[entityKey])
        const canExpand = !showFullDescriptions && description.length > 160
        const entityApiId = getEntityApiId(entity)
        const isVerified = isEntityVerified(entity)
        const isVerifying = phaseBusyAction === `verify:${phase}:${entityApiId}`

        return (
          <div className="creative-direction-chat__entity-item" key={entityKey}>
            <div>
              <strong>
                {entity.name || entity.placeholder || `Item ${index + 1}`}
              </strong>
              <span
                className={`creative-direction-chat__entity-description${
                  isExpanded
                    ? ' creative-direction-chat__entity-description--expanded'
                    : ''
                }`}
              >
                {description}
              </span>
              {canExpand ? (
                <button
                  type="button"
                  className="creative-direction-chat__entity-read-more"
                  aria-expanded={isExpanded}
                  onClick={() => toggleDescription(entityKey)}
                >
                  {isExpanded ? 'Show less' : 'Read more'}
                </button>
              ) : null}
            </div>
            {isVerified ? (
              <span className="creative-direction-chat__entity-status creative-direction-chat__entity-status--verified">
                <Icon type="check-circle" />
                Verified
              </span>
            ) : isActivePhase ? (
              <Button
                size="small"
                icon="check-circle"
                loading={isVerifying}
                disabled={
                  !entityApiId || Boolean(phaseBusyAction) || !onVerifyEntity
                }
                onClick={() => onVerifyEntity(phase, entity)}
              >
                Verify
              </Button>
            ) : (
              <span className="creative-direction-chat__entity-status">
                <Icon type="clock-circle" />
                Waiting
              </span>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default EntityListPreview
